import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Table } from 'antd';
import { OperateSpan } from '../../components/Widgets';
import { ENGLISH, ROLES_KEY, SVC_STATE } from '../../utils/constants';
import './AuditManage.less';
import SvcDetailModal from '../../components/AuditManage/SvcDetailModal';
import { CHINESE } from '../../utils/constants';

class SvcAudit extends PureComponent {
  constructor() {
    super();
    this.state = {
      showSvcDetail: false,
      svcMeeting: {},
      svcDetailMode: 'audit'
    };
  }

  render() {
    const { list = [], current, pageSize, total, userInfo, intl } = this.props;
    const { roleKey } = userInfo;
    const { showSvcDetail, svcMeeting, svcDetailMode } = this.state;
    return (
      <div className="audit-manage">
        <Table
          rowKey={r => r.id}
          columns={[
            {
              title: (
                <div>
                  {intl.formatMessage({ id: 'main_meeting_time' })}
                </div>
              ),
              key: 'showStartTime',
              width: '17%',
              render: record => {
                return (
                  <div>
                    <span>{record.showStartDate}</span>
                    &nbsp;&nbsp;&nbsp;
                    <span>
                      {record.showStartTime.substring(
                        record.showStartTime.indexOf(' ') + 1,
                        record.showStartTime.length
                      )}
                    </span>
                    &nbsp;-&nbsp;
                    <span>
                      {record.showEndTime.substring(
                        record.showEndTime.indexOf(' ') + 1,
                        record.showEndTime.length
                      )}
                    </span>
                  </div>
                );
              }
            },
            {
              title: intl.formatMessage({ id: 'main_meeting_title' }),
              dataIndex: 'name',
              key: 'name',
              width: '23%'
            },
            {
              title: intl.formatMessage({ id: 'main_meeting_room' }),
              dataIndex: 'roomNames',
              key: 'roomNames',
              width: '20%',
              render: record => {
                const { roomNames = '', roomNamesEn = '' } = record;
                return intl.locale === ENGLISH ? roomNamesEn : roomNames;
              }
            },
            {
              title: intl.formatMessage({ id: 'meeting_list_table_creator' }),
              dataIndex: 'holder',
              key: 'holder',
              width: '10%'
            },
            {
              title: intl.formatMessage({ id: 'service_level' }),
              dataIndex: 'svc_level_name',
              key: 'svc_level_name',
              width: '10%'
            },
            {
              title: <div>{intl.formatMessage({ id: 'state' })}</div>,
              key: 'svcAuditState',
              width: '10%',
              render: record => {
                const { svcAuditState } = record;
                switch (svcAuditState) {
                  case SVC_STATE.audit:
                    return (
                      <div className="point-wrapper">
                        <div className="point-audit"/>
                        <FormattedMessage id="meeting_no_approved"/>
                      </div>
                    );
                  case SVC_STATE.reject:
                    return (
                      <div className="point-wrapper">
                        <div className="point-reject"/>
                        <FormattedMessage id="meeting_rejected"/>
                      </div>
                    );
                  case SVC_STATE.agree:
                    return (
                      <div className="point-wrapper">
                        <div className="point-agree"/>
                        <FormattedMessage id="meeting_agree"/>
                      </div>
                    );
                  case SVC_STATE.noAudit:
                    return (
                      <div className="point-wrapper">
                        <div className="point-agree"/>
                        <FormattedMessage id="audit_svc_no_need_audit"/>
                      </div>
                    );
                }
              }
            }
          ].concat(
            roleKey === ROLES_KEY.svc_admin
              ? [
                {
                  title: intl.formatMessage({
                    id: 'meeting_list_table_operate'
                  }),
                  key: 'detail',
                  width: '10%',
                  render: record => {
                    const { svcAuditState } = record;
                    switch (svcAuditState) {
                      case SVC_STATE.audit:
                        return (
                          <OperateSpan
                            onClick={() => {
                              this.setState({
                                svcMeeting: record,
                                showSvcDetail: true,
                                svcDetailMode: 'audit'
                              });
                            }}
                          >
                            {intl.formatMessage({ id: 'meeting_approve' })}
                          </OperateSpan>
                        );
                      default:
                        return (
                          <OperateSpan
                            onClick={() => {
                              this.setState({
                                svcMeeting: record,
                                showSvcDetail: true,
                                svcDetailMode: 'detail'
                              });
                            }}
                          >
                            {intl.formatMessage({ id: 'meeting_detail' })}
                          </OperateSpan>
                        );
                    }
                  }
                }
              ]
              : []
          )}
          dataSource={list}
          pagination={{
            current,
            pageSize,
            total,
            onChange: this.onPageChange
          }}
        />
        <SvcDetailModal
          visible={showSvcDetail}
          svcMeeting={svcMeeting}
          mode={svcDetailMode}
          onClose={() => {
            this.setState({ showSvcDetail: false });
          }}
        />
      </div>
    );
  }

  onPageChange = (current, pageSize) => {
    const { dispatch } = this.props;
    dispatch({ type: 'svcAudit/update', payload: { current, pageSize } });
    dispatch({ type: 'svcAudit/getSvcMeetings' });
  };
}

const mapStateToProps = state => {
  return {
    ...state.svcAudit,
    userInfo: state.login.userInfo
  };
};

export default connect(mapStateToProps)(injectIntl(SvcAudit));



// WEBPACK FOOTER //
// ./src/routes/AuditManage/SvcAudit.js